import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { florenceSCConfig } from "./data";

export default function FlorenceSCPage() {
  return <CityPageTemplate config={florenceSCConfig} />;
}